import React, { useState } from "react";
import { Outlet, Route, Routes, useLocation } from "react-router-dom";
import Footer from "components/Footer/Footer.js";
import Sidebar from "components/Sidebar/SidebarInterpreter";
import Header from "components/Navbars/InterpreterNavbar";
import { AppointmentRoutes } from "views-interpreters/AppointmentList";
import { AvailableRoutes } from "views-interpreters/AvailableJobs";
import { AssignedRoutes } from "views-interpreters/AssignedJobs";
import routesInterpreters from "routes-interpreter";
import { CompletedRoutes } from "views-interpreters/CompletedJobs";
import { loadRecaptchaScript } from "helpers/recaptcha";

function InterpreterLayout(props) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const mainPanel = React.useRef();
  const location = useLocation();

  React.useEffect(() => {
    mainPanel.current.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [location]);

  // Interpreter-portal submissions are reCAPTCHA-protected, so load the script (and its
  // badge) once when the portal mounts rather than on the first submit.
  React.useEffect(() => {
    loadRecaptchaScript();
  }, []);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="wrapper">
      <Sidebar
        {...props}
        routes={routesInterpreters}
        isSidebarOpen={isSidebarOpen}
        toggleSidebar={toggleSidebar}
      />
      <div className={`main-panel ${isSidebarOpen ? "collaped" : ""}`} ref={mainPanel}>
        <Header {...props} toggleSidebar={toggleSidebar} />
        <Routes>
          {routesInterpreters.map((prop, key) => {
            return (
              <Route
                path={prop.path}
                element={prop.component}
                key={key}
              />
            );
          })}

          <Route path="/appointments/*" element={<AppointmentRoutes />} />
          <Route path="/available-jobs/*" element={<AvailableRoutes />} />
          <Route path="/assigned-jobs/*" element={<AssignedRoutes />} />
          <Route path="/completed-jobs/*" element={<CompletedRoutes />} />
        </Routes>
        <Footer fluid />
      </div>
      <Outlet />
    </div>
  );
}

export default InterpreterLayout;
